import { computed } from 'vue';
import { ROUTE_NAMES } from '@/router/conf';
import { useRoute } from 'vue-router';

const useIsSettingsView = () => {
  const route = useRoute();

  const isSettingsLayoutRoute = computed(() => {
    return route.name === ROUTE_NAMES.SETTINGS_LAYOUT;
  });

  const isMatchingSettingsRoute = computed(() => {
    return route.matched.some((route) => route.name === ROUTE_NAMES.SETTINGS_LAYOUT);
  });

  return { isSettingsLayoutRoute, isMatchingSettingsRoute };
};

export default useIsSettingsView;
